export default "__VITE_ASSET__ixO_vtaw__"